// extracted by mini-css-extract-plugin
export default {"container":"PhoneNumberField_container__8flXI","prefix":"PhoneNumberField_prefix__6-G52","number":"PhoneNumberField_number__6FV02"};